import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/taxation")({
  head: () => ({
    meta: [
      ...routeMeta("/services/taxation"),
      { title: "Tax & IRS Services in Winter Garden | CCOB" },
      { name: "description", content: "Tax preparation, planning, filing, and IRS representation from a licensed CPA in Winter Garden." },
      { property: "og:title", content: "Taxation Services — CCOB And Company PA" },
      { property: "og:description", content: "Tax planning, preparation, filing & IRS representation." },
    ],
    links: canonicalLinks("/services/taxation"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Taxation"
      title="Taxation Services"
      subtitle="Full-spectrum tax services — planning, preparation, filings, IRS audit support, resolution, and consulting — all handled by a CPA you can actually reach."
      hero={img.heroTax}
      image={img.tax}
      intro="Our Taxation Services cover everything tax-related, kept distinct from our Financial Audit practice. From year-round planning to IRS audit support and resolution, we deliver clear, strategic guidance for individuals and businesses."
      items={[
        { title: "IRS Audit Support", desc: "Experienced representation and advocacy if the IRS audits your personal or business returns." },
        { title: "Tax Preparation", desc: "Accurate, deduction-aware preparation for individuals, families, and businesses of every size." },
        { title: "Tax Filings", desc: "Timely, electronic federal, state, and multi-state filings with confirmation and clear next steps." },
        { title: "Tax Planning", desc: "Forward-looking, year-round strategies that reduce your annual tax burden and avoid surprises." },
        { title: "Tax Resolution & Compliance", desc: "Help resolving back taxes, notices, penalties, and ongoing compliance obligations." },
        { title: "Tax Consulting", desc: "Plain-language guidance on transactions, entity structure, and complex tax situations." },
      ]}
    />
  ),
});
